export default "__VITE_ASSET__C4k_vGQJ__";